import isEqual from "lodash/isEqual";
import sortBy from "lodash/sortBy";

import { getURLQueryParams, QueryParams, SortParams, FilterParams } from "@regal-voice/ui";

// url params order is not guaranteed
// we consider the params being equal, regardless of the order they appear in
export function areQueryParamsEqual(left: string, right: string): boolean {
    if (left === right) {
        return true;
    }

    const leftQuery = getURLQueryParams(left)?.query;
    const rightQuery = getURLQueryParams(right)?.query;

    const leftQueryKeys = Object.keys(leftQuery).sort();
    const rightQueryKeys = Object.keys(rightQuery).sort();

    if (leftQueryKeys.length !== rightQueryKeys.length) {
        return false;
    }

    return leftQueryKeys.every((key) => {
        const leftValue = leftQuery[key as keyof QueryParams] as SortParams[] | FilterParams[];
        const rightValue = rightQuery[key as keyof QueryParams] as SortParams[] | FilterParams[];

        if (Array.isArray(leftValue)) {
            return isEqual(sortBy(leftValue, "key"), sortBy(rightValue, "key"));
        }

        return isEqual(leftValue, rightValue);
    });
}
